import React from "react";
//스타일패키지
import styled from "styled-components";
//라우터
import { useHistory} from "react-router-dom";
//리덕스 데이터 업데이터 훅
import { useDispatch } from "react-redux";
//리덕스
import {addWordFB} from '../redux/modules/word';
//아이콘
import { TiChevronLeftOutline } from "react-icons/ti";


const WordAdd =(props)=>{
    const history =useHistory();
    const dispatch =useDispatch();

    const word = React.useRef(null); //초기값은 null 단어
    const desc = React.useRef(null); //초기값은 null 설명
    const example = React.useRef(null); //초기값은 null 예시
    

    const allWord =()=>{ 
        const word_v=word.current.value.trim(); //input에 입력된 값을 가져옴 양끝의 공백은 빼고 !
        const desc_v=desc.current.value.trim();
        const example_v=example.current.value.trim();
        

        if(!word_v || !desc_v || !example_v){ //만약 빈칸이라면 
            alert('입력하지 않은 항목이 있네요 ? 🧐');
            return false;
        };
        const word_re ={
            word_v,desc_v,example_v
        };

        return word_re;
        
    }

    const addWord =(e)=>{ //추가해주는 함수
        e.preventDefault();
        const word_re=allWord();
        if (!word_re) return; //이거 안넣으면, 값입력안하고 추가 눌렀을 때 얼럿창만 뜨고 빈 박스가 추가됨..

        const new_word_re = { ...word_re, date: Date.now(), completed: false };
       // console.log(new_word_re)
        
        dispatch(
            addWordFB({
                 word: new_word_re.word_v,
                desc: new_word_re.desc_v,
                example: new_word_re.example_v,
                completed:new_word_re.completed,
                date:new_word_re.date
            })
            
        )
        props.history.push("/");
    };
    return (
        <>
            <AddOutter>
                <div>
                    <h3>단어 추가하기</h3>
                    <WordBox>
                        <div>
                            <label>단어</label>
                            <input type="text" ref={word} /> 
                        </div>
                        <div>
                            <label>설명</label>
                            <input type="text" ref={desc} />
                        </div>
                        <div>
                            <label>예시</label>
                             <input type="text" ref={example} /> 
                        </div>
                        <button type="submit" onClick={addWord}>단어 추가</button>
                    </WordBox>
                    <Back>
                    <ArrowLeft onClick={()=>{
                        history.push("/");
                    }} 
                    />
                    </Back>
                </div>
                
            </AddOutter>
        </>
        )
}
//스타일
const AddOutter=styled.section`
    width:100%;
    position:relative;
    top:80px;
    height:100%;
    padding:60px;
    display:flex;
    justify-content:center;
    
    @media screen and (max-width: 500px){
        top:60px;
        }

        & > div{
            width:400px;
            min-height: 70vh;
            background: #e4ebfb;
            border-radius:8px;
            position:relative;
        }
        & > div> h3{
            width: 100%;
            text-align:center;
            font-size: 36px;
            padding:10px;
            font-family:"Dongle";
            @media screen and (max-width: 500px){
                font-size: 30px;
            }
        }
`;
const WordBox =styled.div`
            width:100%;
            height:320px;
            display:flex;
            flex-direction:column;
            justify-content:center;
            align-items:center;
            gap:50px;

        & div {
            
        }
        & label{
            font-family:"Dongle";
            font-size:32px;
            margin-right:10px;
        }
        & input{
            width:200px;
            height:40px;
            border: 1px solid #97ACE3;
            border-radius:5px;
        }
        & input:focus {
            border: 1px solid #123389;
        }
        & > button {
            width:150px;
            height:40px;
            font-family:"Dongle";
            font-size:32px;
            cursor:pointer;
            border-radius:5px;
            background:#97ACE3;
            color:#123389;
        }
        & > button:hover{
            background:#123389;
            color:#97ACE3;
        }
`;
const Back =styled.button`
    background:none;
    border-radius:5px;
    position:absolute;
    top:25px;
    left: 20px;
    cursor:pointer;
    
`;
const ArrowLeft=styled(TiChevronLeftOutline)`
        transform:scale(2,2);
        transition: transform 300ms ease-in-out;
        &:hover{
                transform: scale(2,2) rotate(360deg);
            }
`;
export default WordAdd;